import { create } from '~/utils/store/createStore';

interface ChatInputState {
  isSubmitButtonPinned: boolean;
  setSubmitButtonPinned: (value: boolean) => void;
  hasUserInteracted: boolean;
  setHasUserInteracted: (value: boolean) => void;
}

export const useChatInputStore = create<ChatInputState>(set => ({
  isSubmitButtonPinned: false,
  setSubmitButtonPinned: (value: boolean) =>
    set({ isSubmitButtonPinned: value }),
  hasUserInteracted: false,
  setHasUserInteracted: (value: boolean) => set({ hasUserInteracted: value }),
}));
